<div class="modal-header">
  <h5 class="modal-title modal-title-center">{{'modals.cancellation-transaction-modal.title' | translate}}</h5>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    <span
      aria-hidden="true"
      [class.disabled]="inProgress"
      (click)="modalRef.hide()"
      >×</span
    >
  </button>
</div>
<div class="modal-body modal-body-center mrl-normal-close-account">
  <p class="text-center w-470 m-25" [innerHTML]="'modals.cancellation-transaction-modal.body-1-html' | translate">
  </p>
  <p class="text-center w-500 m-25" [innerHTML]="'modals.cancellation-transaction-modal.body-2-html' | translate">
  </p>
  <p class="text-center m-25">
    {{'modals.cancellation-transaction-modal.body-3' | translate}}
  </p>
</div>

<div class="modal-footer modal-footer-center-btn">
  <button
    type="button"
    class="btn btn-outline-secondary btn-lg btn-min-w"
    data-dismiss="modal"
    aria-label="Close"
    (click)="hide()"
  >
    {{'modals.cancellation-transaction-modal.no' | translate}}
  </button>
  <button
    type="button"
    class="btn btn-secondary btn-lg btn-min-w InterestAccountclose btn-success-loader"
    (click)="cancel()"
  >
    {{'modals.cancellation-transaction-modal.yes' | translate}}
    <app-loader *ngIf="inProgress"></app-loader>
  </button>
</div>
